<template>
  <ModalBase show-modal auto-h narrow @close-modal="close">
    <template v-slot:titlebar>
      <TitleBar variant-class="title-modal">
        <template v-slot:pretitle>
            {{ (isEdit) ? $gettext('EDIT'): $gettext('ADD') }}
        </template>
        <template v-slot:title>
          <span v-if="isEdit">{{projectDetails.name}}</span>
          <span v-if="!isEdit" v-translate>New project</span>
        </template>
      </TitleBar>
    </template>
    <template v-slot:maincontent>
      <AddEditProject
        ref="addeditproject" 
        v-if="projectDetails && customerId && !loading" 
        :projectDetails="projectDetails" 
        :contactData="customerId" 
        :projectData="projectId" 
        @created="onProjectCreated" 
        @updated="onProjectUpdated"
      />
    </template>
    <template v-slot:actions>
      <GekkoButton 
        @click="$refs.addeditproject.saveForm()"
        icon="fa-solid fa-check"
        :text="$gettext('Save and select')"
        type="submit"
        class="float-right"
      />
    </template>
  </ModalBase>
</template>

<script>
import ModalBase from "@/components/base_components/ModalBase";
import TitleBar from "@/components/TitleBar";
import AddEditProject from "@/components/contacts/AddEditProject"
import GekkoButton from "@/components/GekkoButton";
import ProjectService from "@/store/services/project.service";

export default {
  name: 'InvoiceProjectModal',
  props: {
    customerId: {
      type: Number,
      default: null
    },
    projectId: {
      type: Number,
      default: null
    },
    createProjectName: {
      type: String,
      default: null
    }
  },
  components: { 
    ModalBase,
    TitleBar,
    AddEditProject,
    GekkoButton
  },
  data () {
    return {
      projectDetails: null,
      loading: false
    }
  },
  computed: {
    isEdit () {
      return this.projectId && (!this.createProjectName && this.createProjectName !== '')
    }
  },
  created () {
    console.log('createProjectName', this.createProjectName)
    this.loading = true
    this.setupData()
  },
  methods: {
    close () {
      this.$emit('close')
      document.body.classList.remove('modal-on')
    },
    setupData () {
      this.projectDetails = {
        company: null,
        name: "",
        contact_name: null,
        reference: "",
        description: "",
        hourly_rate: null,
        favorite: false,
      }
      if (this.createProjectName || this.createProjectName === '') {
        this.$set(this.projectDetails, 'name', this.createProjectName)
        this.loading = false
      } else if (this.projectId) {
        this.getProjectDetails(this.projectId)
      }
    },
    getProjectDetails (project_id) {
      ProjectService.retrieve(project_id).then((response) => {
        this.projectDetails = response.data
        this.loading = false
      });
    },
    onProjectCreated (val) {
      this.$emit('project-created', val)
    },
    onProjectUpdated (val) {
      this.$emit('project-updated', val)
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
